document.addEventListener('DOMContentLoaded', function() {
  // Select all variant-selects containers on the page
  const variantSelectsContainers = document.querySelectorAll('variant-selects');

  // Iterate through each variant-selects container
  variantSelectsContainers.forEach((variantSelects) => {
    // Select the SVG caret icon within this container
    let caretIcon = variantSelects.querySelector('.icon-caret');

    if (caretIcon) {
      // Create a button element
      const button = document.createElement('button');
      button.type = 'button'; // Set button type to avoid form submission
      button.classList.add('caret-button'); // Add a class for styling if needed

      // Define the new solid SVG
      const newSolidSvg = `
        <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
          <path d="M0 0h10L5 6z" fill="#000000"></path>
        </svg>
      `;

      // Insert the button before the original SVG
      caretIcon.parentNode.insertBefore(button, caretIcon);

      // Remove the original SVG from the DOM
      caretIcon.remove();

      // Set the button's inner HTML to the new solid SVG content
      button.innerHTML = newSolidSvg;
    }
  });
});
